import React from 'react';
import '../App.css';
import Topnav from '../components/Topnav';
import Hero from './Hero';
import HeroMeta from './HeroMeta';
import About from './About';
import Projects from './Projects';
import CV from './CV';

function Home() {
	return (
		<>
			<Topnav />
			<div className="home">
				<Hero />
				{/* DOM order = reading order (Work, About, meta, CV); the sidebar
				    layout is done with grid placement, not source reordering */}
				<div className="layout">
					<Projects />
					{/* About + sidebar get their own row box, so the sticky sidebar
					    stops where About ends instead of riding over the CV */}
					<div className="about-row">
						<About />
						<aside className="hero-meta-col">
							<HeroMeta />
						</aside>
					</div>
					<CV />
				</div>
			</div>
		</>
	);
}

export default Home;
